export const smts = [
    {
        name: 'Digital Nameplate for industrial equipment',
        idShort: 'Nameplate',
        semanticId: 'https://admin-shell.io/zvei/nameplate/2/0/Nameplate',
        version: '2.0',
    },
    {
        name: 'Digital Nameplate for industrial equipment',
        idShort: 'Nameplate',
        semanticId: 'https://admin-shell.io/idta/nameplate/3/0/Nameplate',
        version: '3.0',
    },
    {
        name: 'Carbon Footprint',
        idShort: 'CarbonFootprint',
        semanticId: 'https://admin-shell.io/idta/CarbonFootprint/CarbonFootprint/0/9',
        version: '0.9',
    },
    {
        name: 'Contact Informations',
        idShort: 'ContactInformations',
        semanticId: 'https://admin-shell.io/zvei/nameplate/1/0/ContactInformations',
        version: '1.0',
    },
    {
        name: 'Handover Documentation',
        idShort: 'HandoverDocumentation',
        semanticId: '0173-1#01-AHF578#001',
        version: '1.2',
    },
    {
        name: 'Hierarchical Structures enabling Bills of Material',
        idShort: 'HierarchicalStructures',
        semanticId: 'https://admin-shell.io/idta/HierarchicalStructures/1/0/Submodel',
        version: '1.0',
    },
    {
        name: 'Hierarchical Structures enabling Bills of Material',
        idShort: 'HierarchicalStructures',
        semanticId: 'https://admin-shell.io/idta/HierarchicalStructures/1/1/Submodel',
        version: '1.1',
    },
    {
        name: 'Generic Frame for Technical Data for Industrial Equipment in Manufacturing',
        idShort: 'TechnicalData',
        semanticId: 'https://admin-shell.io/ZVEI/TechnicalData/Submodel/1/2',
        version: '1.2',
    },
    {
        name: 'Time Series Data',
        idShort: 'TimeSeries',
        semanticId: 'https://admin-shell.io/idta/TimeSeries/1/1',
        version: '1.1',
    },
];
